import { all, call, put, takeLatest } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { setVendorDetails } from './../../Store/Organization/VendorDetails/VendorDetailsAction';
import { GET_VENDOR_DETAILS } from './../../Store/Organization/VendorDetails/VendorDetailsType';
import OrganizationApiService from './OrganizationApiService';
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getVendorDetails(searchText: any): any {

    try {
        const text = searchText.searchText;

        let payloadData : IPayload = {
            apiMethod: apiMethod.GET,
            apiType: apiType.Organization,
            endpoint: text ? `organizations/dropdown/vendor?searchText=${text}` : `organizations/dropdown/vendor`,
            payload : null
        }

        yield put(globalLoaderText("Fetching Data...."));
        const response = yield call(
            OrganizationApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setVendorDetails(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
    }
}

function* watchGetVendorDetails() {
    yield takeLatest(GET_VENDOR_DETAILS, getVendorDetails)
}

export default function* combinedSaga() {
    yield all([
        watchGetVendorDetails()
    ])
}
